import { Modal } from '@shared/ui/kit';
import React from 'react';
import { createPortal } from 'react-dom';

type ModalWrapperProps = React.ComponentProps<typeof Modal>;

export const ModalWrapper: React.FC<ModalWrapperProps> = (props) => {
  return createPortal(<Modal {...props}></Modal>, document.getElementById('modal') as Element);
};
